import '../assets/css/style.min.css'

import { initializeApp } from 'firebase/app'
import { getAuth, onAuthStateChanged, updateProfile } from 'firebase/auth'
import { form, g } from '../../../utils'
import { firebaseConfig } from '../components/config'

const app = initializeApp(firebaseConfig)
const auth = getAuth()

onAuthStateChanged(auth, (user) => {
    if (user) {
        // User is signed in, see docs for a list of available properties
        // https://firebase.google.com/docs/reference/js/firebase.User
        const displayName = user.displayName;
        const email = user.email;
        const photoURL = user.photoURL;
        const emailVerified = user.emailVerified;

        // The user's ID, unique to the Firebase project. Do NOT use
        // this value to authenticate with your backend server, if
        // you have one. Use User.getToken() instead.
        const uid = user.uid;

        g('profile_image').src = photoURL

        if (user.displayName !== undefined) {
            g('input-name').value = user.displayName
        }

        g('input-email').value = user.email


        // g('displayImg').src = user.photoURL

        // g('a_logout').addEventListener('click', (e) => {
        //     e.preventDefault()
        //     auth.signOut()
        // })

        form('account', (data) => {
            console.log(data);

            updateProfile(user, {
                displayName: g('input-name').value
            }).then(() => {
                alert('Updated successfully!')
            })
        })
    } else {
        location.replace('./login/')
    }
});

require('../assets/js/scripts')



// signInWithPopup(auth, provider)
// .then((result) => {
//   // This gives you a Google Access Token. You can use it to access the Google API.
//   const credential = GoogleAuthProvider.credentialFromResult(result);
//   const token = credential.accessToken;
//   // The signed-in user info.
//   const user = result.user;
//   // IdP data available using getAdditionalUserInfo(result)
//   // ...

//   location.reload()
// }).catch((error) => {
//   // Handle Errors here.
//   const errorCode = error.code;
//   const errorMessage = error.message;
//   // The email of the user's account used.
//   const email = error.customData.email;
//   // The AuthCredential type that was used.
//   const credential = GoogleAuthProvider.credentialFromError(error);
//   // ...
// });